// CANONICAL COPY (GH #7115). src/constants/obligations/obl-retention-deletion-per-dpa.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-retention-deletion-per-dpa',
  title: 'Verify per-DPA retention and deletion routines are followed',
  description:
    'Confirm that retention periods and deletion routines agreed in each DPA are documented and actively followed — distinct from the generic deletion policy (`obl-data-deletion`), which addresses data deletion at the end of business need. FSR ISAE 3000 Kontrolmål D.1–D.2 require per-controller, per-DPA schedules with scheduled purges, deletion evidence per dataset, and annual review of the procedure. Review the DPA retention register, sample recent purge jobs against specific DPAs, and the annual procedure-review record.',
  category: 'compliance',
  scfIds: ['SCF-DAT-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Per-DPA retention and deletion procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
